export default {
  methods: {
    logStatusIconName: function (status) {
      let names = {
        0: 'mdi-human-queue',
        1: 'mdi-alert-circle',
        2: 'mdi-timer-outline',
        3: 'mdi-check-circle',
        4: 'mdi-alert-circle',
        5: 'mdi-alert-circle',
        6: 'mdi-alert-circle',
        7: 'mdi-alert-circle',
        8: 'mdi-alert-circle',
        9: 'mdi-alert-circle',
        10: 'mdi-alert-circle',
      };
      return names[status];
    },
    logStatusIconColor(status) {
      const colors = {
        0: 'grey--text text--darken-2',
        1: 'deep-orange--text text--accent-4',
        2: 'grey--text text--darken-2',
        3: 'teal--text',
        4: 'deep-orange--text text--accent-4',
        5: 'deep-orange--text text--accent-4',
        6: 'deep-orange--text text--accent-4',
        7: 'deep-orange--text text--accent-4',
        8: 'deep-orange--text text--accent-4',
        9: 'deep-orange--text text--accent-4',
        10: 'deep-orange--text text--accent-4',
      };
      return colors[status] || 'grey--text';
    },
    logStatusText: function (status) {
      let text = {
        0: 'I kø',
        1: 'Fejl i ftp upload',
        2: 'Uploaded til eboks - venter på resultat',
        3: 'Sendt med succes',
        4: 'Modtager ikke aktiv i eboks',
        5: 'Beskeden er for lang',
        6: 'Modtager findes ikke',
        7: 'Datofejl',
        8: 'Ikke indstillet',
        9: 'Fejl',
        10: 'Fejl hemmelig adresse',
      };
      return text[status];
    },
  }
};